var map = {
	"./Router": 49833,
	"./Router.d": 55249,
	"./Router.d.ts": 55249,
	"./Router.js": 49833,
	"./Router.js.map": 79453,
	"./Router5": 1724,
	"./Router5.d": 83505,
	"./Router5.d.ts": 83505,
	"./Router5.js": 1724,
	"./Router5.js.map": 62064,
	"./Router6": 46905,
	"./Router6.d": 83409,
	"./Router6.d.ts": 83409,
	"./Router6.js": 46905,
	"./Router6.js.map": 94794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92673;